import * as swcHelpers from '@swc/helpers';
import { lensAddOnStepBase } from '../shared/lens-add-on.js';
import { lensAddOnVariantStep } from '../shared/lens-add-on-variant.js';
import { lensPackageStepBase } from '../shared/lens-package.js';
import { lensTypeStepBase } from '../shared/lens-type.js';
import { lensTypeVariantStep } from '../shared/lens-type-variant.js';
import { prescriptionEntrySelectionStepBase } from '../shared/prescription-entry-selection.js';
import { prescriptionFormStepBase } from '../shared/prescription-form.js';
import { prescriptionUploadStepBase } from '../shared/prescription-upload.js';
import { prescriptionValidationStepBase } from '../shared/prescription-validation.js';
import { reviewStepBase } from '../shared/review.js';

const labelKeys = {
    lensType: {
        stepIndicatorTitle: 'products.glasses.configurator.step.lensType',
        title: 'products.glasses.lensType.title',
        description: 'products.glasses.lensType.description'
    },
    lensTypeVariant: {
        title: 'products.glasses.lensTypeVariant.title',
        description: 'products.glasses.lensTypeVariant.description'
    },
    prescription: {
        stepIndicatorTitle: 'products.glasses.configurator.step.prescription',
        title: 'products.glasses.prescription.title',
        description: 'products.glasses.prescription.description'
    },
    prescriptionEntrySelection: {
        stepIndicatorTitle: 'products.glasses.configurator.step.prescription',
        title: 'products.glasses.prescriptionEntry.title',
        description: 'products.glasses.prescriptionEntry.description'
    },
    prescriptionUpload: {
        title: 'products.glasses.prescriptionUpload.title',
        description: 'products.glasses.prescriptionUpload.description'
    },
    prescriptionForm: {
        title: 'products.glasses.prescriptionForm.title',
        description: 'products.glasses.prescriptionForm.description'
    },
    prescriptionValidation: {
        stepIndicatorTitle: 'products.glasses.configurator.step.prescriptionValidation',
        title: 'products.glasses.validationStep.title',
        description: 'products.glasses.validationStep.description'
    },
    lensPackage: {
        stepIndicatorTitle: 'products.glasses.configurator.step.lensPackage',
        title: 'products.glasses.lensPackage.title',
        description: 'products.glasses.lensPackage.description'
    },
    lensAddOn: {
        stepIndicatorTitle: 'products.glasses.configurator.step.lensAddOn',
        title: 'products.glasses.lensAddOn.title',
        description: 'products.glasses.lensAddOn.description'
    },
    lensAddOnVariant: {
        title: 'products.glasses.lensAddOnVariant.title',
        description: 'products.glasses.lensAddOnVariant.description'
    },
    review: {
        stepIndicatorTitle: 'products.glasses.configurator.step.review',
        title: 'products.glasses.review.title',
        description: 'products.glasses.review.description'
    }
};
const stepsMap = {
    lensType: swcHelpers.objectSpread({}, lensTypeStepBase, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys.lensType, {
            alternativeCta: 'products.glasses.lensType.selectVariant'
        })
    }),
    lensTypeVariant: swcHelpers.objectSpread({}, lensTypeVariantStep, {
        labelKeys: labelKeys.lensTypeVariant
    }),
    prescription: swcHelpers.objectSpread({}, prescriptionEntrySelectionStepBase, {
        labelKeys: labelKeys.prescriptionEntrySelection
    }),
    prescriptionUpload: swcHelpers.objectSpread({}, prescriptionUploadStepBase, {
        labelKeys: labelKeys.prescriptionUpload
    }),
    prescriptionForm: swcHelpers.objectSpread({}, prescriptionFormStepBase, {
        labelKeys: labelKeys.prescriptionForm
    }),
    prescriptionValidation: swcHelpers.objectSpread({}, prescriptionValidationStepBase, {
        labelKeys: labelKeys.prescriptionValidation
    }),
    lensPackage: swcHelpers.objectSpread({}, lensPackageStepBase, {
        labelKeys: labelKeys.lensPackage
    }),
    lensAddOn: swcHelpers.objectSpread({}, lensAddOnStepBase, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys.lensAddOn, {
            alternativeCta: 'products.glasses.lensAddOn.selectVariant'
        })
    }),
    lensAddOnVariant: swcHelpers.objectSpread({}, lensAddOnVariantStep, {
        labelKeys: labelKeys.lensAddOnVariant
    }),
    review: swcHelpers.objectSpread({}, reviewStepBase, {
        labelKeys: labelKeys.review
    })
};

export { stepsMap };
//# sourceMappingURL=index.js.map
